import { MRT_SortingState, MRT_TableState } from "material-react-table";

import { ProspectRow } from "../types";
import { submissionTimeField } from "./model";

export const defaultProspectPageSize = 25;

export const DEFAULT_SORTING: MRT_SortingState = [
  { id: submissionTimeField, desc: true },
];

export const DEFAULT_SHOW_COLUMN_FILTERS = true;

export const DEFAULT_SHOW_GLOBAL_FILTER = true;

export const prospectTableInitialState: Partial<MRT_TableState<ProspectRow>> = {
  columnPinning: {
    left: ["projectName"],
  },
  pagination: {
    pageIndex: 0,
    pageSize: defaultProspectPageSize,
  },
  showColumnFilters: DEFAULT_SHOW_COLUMN_FILTERS,
  showGlobalFilter: DEFAULT_SHOW_GLOBAL_FILTER,
  sorting: DEFAULT_SORTING,
};
